import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventLandingInstantOfferMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config

    this._TRACKING_EVENT_NAMES = this._config.get('tracking').TRACKING_EVENT_NAMES
    this._HIT_INFORMATIONS = this._config.get('tracking').HIT_INFORMATIONS
    this._TRACKING_PAGE_ERRORS = this._config.get('tracking').TRACKING_PAGE_ERRORS
    this._fieldNameToTrackingIds = config.get('form').fieldNameToTrackingIds
    this._formErrorTypes = config.get('form').formErrorTypes
    this._formFieldIds = config.get('form').formFieldIds
  }

  setParams({fieldId, formErrors, isPrivacyChecked, vehicleData}) {
    this._fieldId = fieldId
    this._formErrors = formErrors
    this._isPrivacyChecked = isPrivacyChecked
    this._vehicleData = vehicleData
    return this
  }

  mapFieldAutocompleted() {
    return {
      event: this._TRACKING_EVENT_NAMES.LANDING_IO_FIELD_AUTOCOMPLETED,
      data: {
        hit_information: this._HIT_INFORMATIONS.ONLY_CHOICE,
        pta_automatic_field: this._fieldNameToTrackingIds[this._fieldId].property
      }
    }
  }

  mapFieldSelected() {
    return {
      event: `Landing IO ${this._fieldNameToTrackingIds[this._fieldId].field} Selected`
    }
  }

  mapFormFieldsError() {
    const {email, name, phone, privacyCheck} = this._formFieldIds

    const isUserFieldsError = Object.keys(this._formErrors).some(errorKey => {
      return [email, name, phone, privacyCheck].some(fieldId => fieldId === errorKey)
    })

    const event = isUserFieldsError
      ? this._TRACKING_EVENT_NAMES.LANDING_IO_OFFER_REQUESTED_ERROR
      : this._TRACKING_EVENT_NAMES.LANDING_IO_NEXT_ERROR

    const privacyCheckError = !this._isPrivacyChecked
      ? this._fieldNameToTrackingIds[this._formFieldIds.privacyCheck].property
      : ''

    const data = {
      page_error: this._TRACKING_PAGE_ERRORS.FIELD_ERROR,
      form_fields: Object.keys(this._formErrors).reduce((acc, fieldKey) => {
        const fieldError = this._formErrors[fieldKey]
        const fieldErrorId = this._fieldNameToTrackingIds[fieldKey].property
        if (!fieldError.length) return acc
        return !acc ? fieldErrorId : `${acc}:${fieldErrorId}`
      }, privacyCheckError)
    }

    return {
      event,
      data
    }
  }

  mapNextViewed() {
    return {
      event: this._TRACKING_EVENT_NAMES.LANDING_IO_NEXT_VIEWED,
      data: {
        channel: 'ad post',
        page_category_level1: 'oferta instantanea',
        page_name: 'insertion datos landing instant offer pagina 2',
        page_type: 'form'
      }
    }
  }

  mapNextConfirmed() {
    const event = {
      event: this._TRACKING_EVENT_NAMES.LANDING_IO_NEXT_CONFIRMED
    }

    if (this._vehicleData) {
      const vehicleData = this._vehicleData

      const formFields = Object.keys(vehicleData)
        .reduce((previus, current) => {
          !vehicleData[current] && previus.push(this._fieldNameToTrackingIds[current].property)
          return previus
        }, [])
        .join(':')

      if (formFields) {
        event.data = {
          form_fields: formFields
        }
      }
    }
    return event
  }

  mapOfferRequestedError() {
    return {
      event: this._TRACKING_EVENT_NAMES.LANDING_IO_OFFER_REQUESTED_ERROR,
      data: {
        page_error: this._TRACKING_PAGE_ERRORS.NEW_AD_NO_TARGET
      }
    }
  }

  map(eventName) {
    switch (eventName) {
      case this._TRACKING_EVENT_NAMES.LANDING_IO_FIELD_AUTOCOMPLETED:
        return this.mapFieldAutocompleted()

      case this._TRACKING_EVENT_NAMES.LANDING_IO_FIELD_SELECTED:
        return this.mapFieldSelected()

      case this._TRACKING_EVENT_NAMES.LANDING_IO_FORM_FIELDS_ERROR:
        return this.mapFormFieldsError()

      case this._TRACKING_EVENT_NAMES.LANDING_IO_NEXT_CONFIRMED:
        return this.mapNextConfirmed()

      case this._TRACKING_EVENT_NAMES.LANDING_IO_NEXT_VIEWED:
        return this.mapNextViewed()

      case this._TRACKING_EVENT_NAMES.LANDING_IO_OFFER_REQUESTED_ERROR:
        return this.mapOfferRequestedError()

      default:
        return {event: eventName}
    }
  }
}
